import React from "react";
import Gift from "../Gift Page/gift";
import Hero from "../Hero Page/Task/hero";
import Leader from "../Leader Page/leader";
import Profile from "../Profile Page/Profile";
import Settings from "../Settings Page/settings";

export default function Content({ active, isEdit, setEdit }) {
  return (
    <div className="content">
      {active === "hero" && <Hero isEdit={isEdit} setEdit={setEdit} />}
      {active === "gift" && <Gift />}
      {active === "leader" && <Leader />}
      {active === "profile" && <Profile />}
      {active === "settings" && <Settings />}
    </div>
  );
}
